import { IncidentRule } from "./incidentsRules";

export const helpQuestion: IncidentRule[] = [
    {
        question: "How do I block an account?",
        answer: "If you want to block any user’s account, you can do it simply by long press on the profile. By long pressing, a list of table will appear containing block, mute, unfollow and hide all posts. From this select block option."
    },
    {
        question: "How can I access/update my information?",
        answer: "You can update your information from profile menu."
    },
    {
        question: "How is my information protected?",
        answer: "As Momeento is based on sharing publicly photos or videos of users content, we want users to share content carefully about they share and communicate through their content."
    },
    {
        question: "Whom is my information shared with?",
        answer: "Your information is been used about how you interact with people in the app in order to express to you, to keep you and your community harmless and also for the one who uses it."
    },
    {
        question: "How long will momeento keep/retain my data ?",
        answer: "We retain your information related to profile and content till the duration of your account. We may keep certain information longer than our limited policies specified so that we comply with legal necessity and for safety and security. We keep log data for maximum 100 days."
    },
    {
        question: "Can I delete my messages?",
        answer: "Yes !! You can delete your messages. But take a note that your messages will be deleted from your side only and not from other side. They still have those messages that you have deleted."
    },
    {
        question:
            "Can I switch my account from public to private or vice versa?",
        answer: `If you think you don’t want your account to be private or public, just follow below given simple steps : <br/>
Step 1: Click on the profile on upper left corner<br/>
Step 2: Go on the option “Settings and Privacy”<br/>
Step 3: Press on “Your Account”<br/>
Step 4: Here you can see the option “Status Visibility”. By clicking on the option you can choose whether you want to keep your account private or public.<br/>`
    },
    {
        question: "How can I switch my account?",
        answer: "If you want to switch account from one to another, press on the profile picture, on upper right hand side corner there will appear a option for account switching. Clicking on that option, a list of your account that you have will appear."
    }
];
